export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";